import {Box, Tab, Tabs} from "@mui/material";
import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import TabPanel from "../TabPanel";
import {EMPTY_UI} from "../../../../variables";

type TabConfig = {
    label: string;
    content: React.ReactNode;
};
interface TabSectionProps {
    title: string;
    tabs: TabConfig[];
    onChange?: (event: React.SyntheticEvent, newValue: number) => void;
    initialTab?: number;
    dataTest?: string;
    navigationTabs?: {label: string; to: string}[];
}

const TabSection = ({
    title,
    tabs = [],
    onChange,
    initialTab = 0,
    dataTest = "tabSection",
    navigationTabs = [],
}: TabSectionProps) => {
    const [activeTab, setActiveTab] = useState(initialTab);

    const handleChange = (event: React.SyntheticEvent, newValue: number | string) => {
        if (typeof newValue !== "number") {
            return;
        }
        setActiveTab(newValue);
        onChange?.(event, newValue);
    };

    useEffect(() => {
        setActiveTab(initialTab);
    }, [initialTab]);

    return (
        <Box data-test={dataTest}>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                aria-label={title}
                data-test={dataTest ? `${dataTest}.tabs` : undefined}
            >
                {tabs.map((tab: TabConfig, index: number) => (
                    <Tab
                        value={index}
                        label={tab.label}
                        key={`tab_${tab.label}`}
                        data-test={dataTest ? `${dataTest}.tab.${index}` : undefined}
                    />
                ))}
                {navigationTabs.map((tab) => (
                    <Tab component={Link} to={tab.to} value={tab.to} label={tab.label} key={tab.to} />
                ))}
            </Tabs>
            {tabs.map((tab: TabConfig, index) => (
                <TabPanel value={activeTab} index={index} key={`tab_panel_${tab.label}`}>
                    {tab.content || EMPTY_UI}
                </TabPanel>
            ))}
        </Box>
    );
};

export default TabSection;
